module.exports = __webpack_public_path__ + "img/148.ca28c9cb.jpg";